import React from "react";
import { useNavigate } from "react-router-dom";
import Nav from "./Navigation.js";

export default function LoginRequired() {
  const navigate = useNavigate();
  return (
    <div className="text-white">
      <Nav />
      <div className="flex flex-col items-center justify-center mt-24 px-4">
        <div className="border border-gray-600 rounded-lg p-8 max-w-sm w-full text-center">
          <h2 className="text-xl font-bold mb-3">Login Required</h2>
          <p className="text-gray-300 mb-6">
            You need to be logged in to use this feature.
          </p>
          <div className="flex justify-center gap-4">
            <button
              onClick={() => navigate("/login")}
              className="px-4 py-2 border rounded hover:bg-gray-700"
            >
              Log In
            </button>
            <button
              onClick={() => navigate("/signup")}
              className="px-4 py-2 border rounded hover:bg-gray-700"
            >
              Create Account
            </button>
            <button
              onClick={() => navigate("/")}
              className="px-4 py-2 border rounded hover:bg-gray-700"
            >
              Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
